<template>
    <!--  VISTA LISTAR-->
    <template v-if="view === 'listar'">
        <HeaderComponent :title="title" :entity="entity" :clean-form="cleanLoadSelectedData"
            @updateValues="setupUpdateValues"></HeaderComponent>
        <FilterRefactComponent :auth-token="authToken" :list-api="listApi" :table-columns="tableColumns"
            :queries="queries" @updateValues="setupUpdateValues"></FilterRefactComponent>
        <TableComponent :entity="entity" :selected-data="selectedEntidadCobro" :table-columns="tableColumns"
            :collection-data="collectionData" :auth-token="authToken" :list-api="listApi"
            @updateValues="setupUpdateValues" 
            :custom-update-selected-data="customUpdateSelectedData" :updatePermission="'update_secretarias_ejecutoras'">
        </TableComponent>
        <PaginateRefactComponent :auth-token="authToken" :list-api="listApi" :paginate="paginate"
            :optionalParams="queries" @updateValues="setupUpdateValues"></PaginateRefactComponent>
    </template>
    <!--    VISTA CREAR - ACTUALIZAR-->
    <template v-else>
        <CreateUpdateComponent :view="view" :paginate="paginate" :selected-data="selectedEntidadCobro"
            :load-data="loadEntidadCobro" :entity="entity" :auth-token="authToken" :list-api="listApi"
            :queries="queries" @updateValues="setupUpdateValues">
            <component :is="childFormComponent" :load-data="loadEntidadCobro"
                :custom-update-value-data="customUpdateValueData"
                @updateValues="setupUpdateValues"></component>
        </CreateUpdateComponent>
    </template>
</template>
<script>

import HeaderComponent from "@/layouts/main/HeaderComponent";
import FilterRefactComponent from "@/layouts/FilterRefactComponent";
import TableComponent from "@/layouts/main/TableComponent";
import PaginateRefactComponent from "@/layouts/PaginateRefactComponent";
import CreateUpdateComponent from "@/layouts/main/CreateUpdateComponent";
import { useAuth } from "@/components/auth/store/composables";
import { reactive, ref } from "vue";
import { useLayoutMain } from "@/layouts/main";
import EntidadCobroCoactivoCrearActualizarComponent from "./components/EntidadCobroCoactivoCrearActualizarComponent.vue";
export default {
    name: "EntidadCobroCoactivo",
    components: {
        HeaderComponent,
        FilterRefactComponent,
        TableComponent,
        PaginateRefactComponent,
        CreateUpdateComponent,
        EntidadCobroCoactivoCrearActualizarComponent
    },
    data: function () {
        return {
            Object: Object,
            title: 'Entidad Cobro Coactivo',
            entity: { gender: 'f', value: 'Entidad Cobro Coactivo' },
            childFormComponent: 'EntidadCobroCoactivoCrearActualizarComponent',
            tableColumns: {
                'id': {
                    isFilter: false,
                    isOrder: false,
                    isVisibleInTable: true,
                    value: 'ID',
                },
                'nombre_entidad': {
                    isFilter: true,
                    isOrder: true,
                    isVisibleInTable: true,
                    value: 'Nombre de la Entidad',
                },
                'estado': {
                    isFilter: true,
                    isOrder: true,
                    isVisibleInTable: false,
                    value: 'Estado'
                },
                'created_at': {
                    isFilter: true,
                    isOrder: true,
                    isVisibleInTable: false,
                    value: 'Fecha de creación',
                },
            }
        };
    },
    async setup() {
        const authStored = useAuth();
        const view = ref('listar');
        const collectionData = ref([]);
        const authToken = ref(authStored.authToken);
        const selectedEntidadCobro = ref({
            id: '',
            nombre_entidad: '',
            estado: ''
        });
        const loadEntidadCobro = ref({
            nombre_entidad: '',
        });
        const listApi = reactive({
            create: process.env.VUE_APP_NEST_ENTIDADCOBRO_CREATE,
            list: process.env.VUE_APP_NEST_ENTIDADCOBRO_FINDALL,
            update: process.env.VUE_APP_NEST_ENTIDADCOBRO_UPDATE,
            updateState: process.env.VUE_APP_NEST_ENTIDADCOBRO_UPDATESTATE
        });
        const customUpdateValueData = (key, value) => {
            return value;
        };

        const {
            paginate,
            queries,
            setupUpdateValues,
            cleanLoadSelectedData
        } = await useLayoutMain(view, collectionData, authToken, selectedEntidadCobro, loadEntidadCobro, listApi);
        return {
            view,
            collectionData,
            authToken,
            selectedEntidadCobro,
            loadEntidadCobro,
            listApi,
            paginate,
            queries,
            setupUpdateValues,
            cleanLoadSelectedData,
            customUpdateValueData,
        };
    }
};
</script>